// API 站台 base URL（不含結尾斜線），集中管理，切換站台/版本只需改此處
export const API_BASE = {
  // https://fhy.wra.gov.tw/Api/v2/...
  FHY_V2: "https://fhy.wra.gov.tw/Api/v2",
  // https://fhy.wra.gov.tw/OpenApiv3/v2/...
  OPENAPI_V3: "https://fhy.wra.gov.tw/OpenApiv3/v2",
};

// 認證金鑰，由 .env 的 VUE_APP_API_KEY 注入（build 時內嵌）
export const API_KEY = process.env.VUE_APP_API_KEY || "";

// 判斷一個請求 URL 是否屬於「需要 apikey 認證」的站台
export function isAuthRequired(url = "") {
  return Object.values(API_BASE).some((base) => url.startsWith(base));
}
